<template>
  <div>
    <div class="card-body">
      <InspectionServiceForm :inspectionService="currentService"
      :serviceTypeIsImagery="isInspectionServiceImagery(currentService)" />
    </div>
    <div class='card-footer right-align-content'>
      <b-button variant="danger"
        class="button-row-spacing"
        v-b-modal="'cancelInspectionServiceForm'"
        :disabled="submitting">
        Cancel
      </b-button>
      <b-button @click="submitWrapper()"
        :disabled="submitting">
        Save
      </b-button>
    </div>
    <CancelModal
      :modalId="'cancelInspectionServiceForm'"
      @cancelled="cancelConfirmed">
    </CancelModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CancelModal from '@/components/CancelModal.vue';
import FormSubmit from '@/mixins/FormSubmit';
import InspectionServiceForm from '@/components/service/InspectionServiceForm.vue';

export default {
  name: 'InspectionDetailsForm',
  components: {
    InspectionServiceForm,
    CancelModal,
  },
  mixins: [FormSubmit],
  data() {
    return {
    };
  },
  computed: {
    ...mapState('Service', {
      submitting: state => state.submitting,
      currentService: state => state.currentService,
      isInspectionServiceEdit: state => state.isInspectionServiceEdit,
    }),
    ...mapGetters('Service', ['isInspectionServiceImagery']),
  },
  mounted() {
  },
  methods: {
    stopEditing() {
      this.$store.dispatch('Service/stopInspectionEditing');
      this.$store.dispatch('Common/stopEditMode', 'InspectionService');
    },
    cancelConfirmed() {
      this.stopEditing();
      if (!this.currentService.id) {
        this.$router.push({
          name: 'projectServices',
          params: { project_id: parseInt(this.$route.params.project_id, 10) },
        });
      } else {
        this.$store.dispatch('Service/resetServices').then(() => {
          this.$store.dispatch('Service/fetchServices', this.$route.params.project_id).then(() => {
            this.$router.push({
              name: 'projectService',
              params: {
                project_id: parseInt(this.$route.params.project_id, 10),
                id: this.currentService.id,
              },
            });
          });
        });
      }
    },
    submitWrapper() {
      if (this.isInspectionServiceEdit) {
        this.currentService.isServiceEdit = true;
      }
      this.onSubmit(this.currentService, 'Service', null, this.stopEditing);
    },
  },
};
</script>
